module.exports = __webpack_public_path__ + "img/g5 - lazy.1cd61081.png";